import { render } from "./EditProjectModal.vue?vue&type=template&id=7df953d7&scoped=true"
import script from "./EditProjectModal.vue?vue&type=script&lang=js"
export * from "./EditProjectModal.vue?vue&type=script&lang=js"

import "./EditProjectModal.vue?vue&type=style&index=0&id=7df953d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df953d7"]])

export default __exports__